import { request, type RequestOptions } from './client';
import type { ApiContractTemplate, ApiDojo } from './types';

export function fetchDojo(options: RequestOptions = {}): Promise<ApiDojo> {
  return request<ApiDojo>('/dojo', options);
}

export function fetchContractTemplate(options: RequestOptions = {}): Promise<ApiContractTemplate> {
  return request<ApiContractTemplate>('/dojo/contract-template', options);
}

export function updateContractTemplate(
  input: { text: string; enabled: boolean },
  options: RequestOptions = {}
): Promise<ApiContractTemplate> {
  return request<ApiContractTemplate>('/dojo/contract-template', {
    ...options,
    method: 'PUT',
    body: input
  });
}
